module.exports = __webpack_public_path__ + "img/appAsset-http--403-ax.ff758d89.svg";